export default "__VITE_PUBLIC_ASSET__ef60abda__"